import { BaseDto } from './base.dto';
export class MerchantGoogleAnalyticsDto extends BaseDto {
  id: number;
  merchantId: number;
  googleHeadScript: string;
  googleBodyScript: string;
  googleTag: string;
}
